export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 80,
    showHeaderOverflow: true,

    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    align: 'center',
    width: 120,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_product_name') || '选品名称',
    field: 'sampleName',
    minWidth: 210,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'sampleNameInfo' },
  },
  {
    title: that.$l('table_label_status') || '状态',
    field: 'status',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_development_nodes') || '开发节点',
    field: 'devStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'devStatus' },
  },
  {
    title: that.$l('table_label_product_fabrics') || '选品面料',
    field: 'sampleContent',
    minWidth: 280,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_product_size') || '选品尺寸',
    field: 'sampleSize',
    width: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'sampleSize' },
  },
  {
    title: that.$l('table_label_cost_factory') || '样品成本价/工厂',
    field: 'smcFtyPrice',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'smcFtyPrice' },
  },
  {
    title: that.$l('table_label_cust_name') || '客户',
    field: 'custName',
    width: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'custName' },
  },
  {
    title: that.$l('table_label_product_source') || '选品来源',
    field: 'purposeOrIssue',
    width: 210,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_selector') || '选品人',
    field: 'selector',
    width: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'selector' },
  },
  {
    title: that.$l('table_label_original_sample') || '原始样品',
    field: 'originalSample',
    width: 280,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'originalSample' },
  },
  {
    title: that.$l('table_label_category_size') || '品类/来源/尺寸',
    field: 'categoryAndSize',
    width: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'categoryAndSize' },
  },
  {
    title: that.$l('table_label_modify') || '最新变动',
    field: 'modify',
    width: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modify' },
  },
]
